module.exports = __webpack_public_path__ + "img/aws.a1722d36.svg";